<template>
  <div>
    <el-dialog title="追加赔款表单" :close-on-click-modal="false" :visible.sync="dialogVisible" width="1242px" center>
      <div class="addGoods">
        <!-- 订单好 -->
        <div class="type">
          <!-- 订单号 -->
          <span>{{ $t("message.orderNumber") }} :</span>
          <div class="input">
            <el-input v-model="order_sn" size="small" onfocus="this.select()" @blur="orderDetails"></el-input>
          </div>
        </div>
        <div class="table">
          <ol>
            <li class="flex05">NO</li>
            <li class="flex05"><el-checkbox v-model="checked" @change="allChecked"></el-checkbox></li>
            <!-- 番号 -->
            <li class="flex05">{{ $t("message.mash") }}</li>
            <!-- 图片 -->
            <li>{{ $t("message.pic") }}</li>
            <!-- 商品属性 -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!-- 商品数量 -->
            <li>{{ $t("message.numberOfProducts") }}</li>
            <!-- option -->
            <li>option</li>
            <!-- 客户备注 -->
            <li class="flex15">{{ $t("message.commodityNote") }}</li>
            <!-- 业务备注 -->
            <li>{{ $t("message.serviceRemarks") }}</li>
          </ol>
          <div class="list-box">
            <ul v-for="(item, index) in tableData" :key="index">
              <li class="flex05">{{ index + 1 }}</li>
              <li class="flex05"><el-checkbox v-model="item.checked" @change="check"></el-checkbox></li>
              <!-- 番号 -->
              <li class="flex05">{{ item.sorting }}</li>
              <!-- 图片 -->
              <li>
                <a :href="item.link" target="_blank">
                  <el-image :src="item.pic" style="width: 60px; height: 60px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                    <div slot="error" class="image-slot">
                    </div>
                  </el-image>
                </a>
              </li>
              <!-- 商品属性 -->
              <li class="flex15">
                <div class="template">
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                        style="margin-bottom: 5px">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                    <div>
                      <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex">
                        {{ itemDetail.key }}：{{ itemDetail.value }}
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <!-- 商品数量 -->
              <li>
                {{ item.confirm_num }}
              </li>
              <!-- option -->
              <li>
                <div style="overflow: hidden;">
                  <el-tooltip placement="bottom">
                    <div slot="content">
                      <div class="row" v-for="(opti, optiIndex) in item.option" :key="optiIndex"
                        style="margin-bottom: 3px">
                        <p>
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span>{{ opti.num }} * {{ opti.price }}{{ opti.unit }}</span>
                        </p>
                      </div>
                    </div>
                    <div style="height: 100px">
                      <div class="row" v-for="(opti, optiIndex) in item.option" :key="optiIndex">
                        <p>
                          {{ optiIndex + 1 }}.{{ opti.name }}:
                          <span>{{ opti.num }}*{{ opti.price }}{{ opti.unit }}</span>
                        </p>
                      </div>
                    </div>
                  </el-tooltip>
                </div>
              </li>
              <!-- 商品备注 -->
              <li class="flex15">
                {{ item.client_remark }}
              </li>
              <!-- 业务备注 -->
              <li>
                {{ item.y_reply }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.save") }}
        </el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [
      ],
      order_sn: '',
      dialogVisible: false,
      checked: false,
    };
  },
  computed: {

  },
  methods: {
    // 订单详情
    orderDetails() {
      if (this.order_sn == '') return false
      this.$api.orderApi.orderDetails({ order_sn: this.order_sn }).then(res => {
        res.data.order_detail.forEach(item => {
          item.checked = false
        }
        )
        this.tableData = res.data.order_detail
        console.log(res);
      })
    },
    //全选
    allChecked() {
      this.tableData.forEach(item => {
        item.checked = this.checked
      })
    },
    // 单选
    check() {
      this.checked = this.tableData.every(item => item.checked)
      this.$forceUpdate()
    },
    //保存
    save() {
      let list = []
      this.tableData.forEach(item => {
        if (item.checked) {
          list.push(item)
        }
      })
      if (list == false) return this.$message.error(this.$t('message.selectableOperationalList'))

      this.$parent.claimIndemnity(list)
      this.dialogVisible = false
    },

  },
  watch: {
    dialogVisible() {
      this.order_sn = ''
      this.tableData = []
    }
  }

};
</script>
<style lang='scss' scoped>
.addGoods {
  padding: 24px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;

  .type {
    display: flex;
    margin-bottom: 20px;
    line-height: 32px;



    .input {
      width: 300px;
      margin-left: 10px;
    }
  }



  .table {

    position: relative;

    ol {
      display: flex;
      height: 40px;
      background: #edeff4;
      border-radius: 4px 4px 0px 0px;
      justify-content: center;
      align-items: center;
      position: sticky;

      li {
        height: 40px;
        text-align: center;
      }
    }

    .list-box {
      max-height: 550px;
      overflow-y: auto;
    }

    ul {
      display: flex;
      padding: 10px 0;
      border-bottom: 1px solid #edeff4;
    }

    li {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 5px;

      &:nth-last-child(1) {
        margin-right: 0;
      }
    }

    .flex2 {
      flex: 3;
    }

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.8;
    }

    .template {
      width: 100%;
      padding: 10px;
      background-color: #fff;
      height: 80px;
      overflow: hidden;
      cursor: pointer;
    }
  }
}

/deep/.el-textarea__inner {
  padding: 5px;
  min-height: 63px !important;
  height: 100px !important;
}
</style>